export default __webpack_public_path__ + "static/media/selimage.96033f13.png";